import { List, Record } from "immutable";

export type ModuleIds = List<string>;

export type SectionStatType = {
  sectionId: string | undefined;
  sessionsCompleted: number;
  totalStudyTime: number;
  lastStudied: string | null | undefined;
  sessionModulesStudied: number;
  averageScore: number | null;
  bestScore: number | null;
  lastScore: number | null;
  spacing: number | null;
  proficiency: number | null | undefined;
  moduleIdsStudied: ModuleIds;
  moduleIdsIncorrectLast: ModuleIds;
  // DEPRECATED
  numberOfNotesOnlySessions: number;
};

const defaultValues: SectionStatType = {
  sectionId: undefined,
  sessionsCompleted: 0,
  totalStudyTime: 0,
  lastStudied: null,
  sessionModulesStudied: 0,
  averageScore: null,
  bestScore: null,
  lastScore: null,
  spacing: null,
  proficiency: 0,
  moduleIdsStudied: List(),
  moduleIdsIncorrectLast: List(),
  numberOfNotesOnlySessions: 0
};

export default class SectionStat extends Record(defaultValues) {}
